import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { TMainNewsItem } from '../../../../types/mainNews';
import { formatDate, formatTimeInMoscow, useApplicationContext } from '../../../../utils';
import { getDate } from './utils/getDate';
import * as s from './NewsItem.css';

/** Элемент списка */
export const NewsItem = ({ id, title, slug, datePublish, noIndex }: TMainNewsItem) => {
  const { custom } = useApplicationContext();
  const referenceNow = useMemo(
    () => new Date(custom.serverTimestamp ?? Date.now()),
    [custom.serverTimestamp],
  );
  const datePublishObject = new Date(datePublish);

  const dateLabel = useMemo(
    () => getDate(datePublishObject, referenceNow),
    [datePublishObject, referenceNow],
  );
  const dateTitle = useMemo(
    () => `${formatDate(datePublishObject, { referenceNow })} в ${formatTimeInMoscow(datePublishObject)}`,
    [datePublishObject, referenceNow],
  );

  const date = (
    <span className={`${s['date']}`} title={dateTitle}>
      {dateLabel}
    </span>
  );

  const newsItem = (
    <>
      <Link to={`/novosti-${slug}-${id}/`} className={`${s['title']}`}>
        {title}
      </Link>

      {date}
    </>
  );

  return (
    <div className={`${s['wrapper']}`} data-web-ui-test-id="NewsItem">
      {noIndex ? <noindex>{newsItem}</noindex> : newsItem}
    </div>
  );
};
